import bluePawn from '../images/pawns/blue-pawn.png';
import greenPawn from '../images/pawns/green-pawn.png';
import redPawn from '../images/pawns/red-pawn.png';
import yellowPawn from '../images/pawns/yellow-pawn.png';
import greyPawn from '../images/pawns/grey-pawn.png';

const pawnImages = {
    green: greenPawn,
    blue: bluePawn,
    red: redPawn,
    yellow: yellowPawn,
    grey: greyPawn,
};

export default pawnImages;